/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { FormattedText, Text } from "@bottlebooks/gatsby-design-system";
import { Flex, Link } from "@bottlebooks/gatsby-theme-base/src";
import { Trans } from "@lingui/macro";
import { ArrowSquareOut } from "@phosphor-icons/react";
import { graphql } from "~/gql";
import Section from "../Section/Section";

export default function ProductDescription({ product, ...rest }) {
  if (!hasContent(product)) return null;
  return (
    <Section title={<Trans>Description</Trans>} {...rest}>
      <FormattedText
        variant="large"
        text={product.description || product.consumerDescription}
      />
      {product.website && (
        <Link
          href={product.website}
          target="_blank"
          rel="noopener noreferrer"
          variant="text"
        >
          <Flex align="center" gap={2}>
            <Text>
              <Trans>Read more on company website</Trans>
            </Text>
            <ArrowSquareOut />
          </Flex>
        </Link>
      )}
    </Section>
  );
}
ProductDescription.hasContent = hasContent;

function hasContent(product) {
  if (!product) return false;
  if (product.description) return true;
  if (product.consumerDescription) return true;
  return false;
}

export const fragment = graphql(`
  fragment bb_ProductDescription on Bottlebooks_Product {
    description
    consumerDescription
  }
`);

ProductDescription.fragment = gql`
  fragment ProductDescription on Product {
    description
    consumerDescription
  }
`;
